import { Button } from '../ui/button';
import { Link, Download } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="py-12 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center gap-2">
              <span className="text-xl font-bold text-red-500">SPYFALL</span>
            </div>
            <div className="flex gap-6">
              <button 
                onClick={() => navigate('/app/privacy')} 
                className="text-sm text-gray-400 hover:text-white transition-colors"
              >
                Privacy Policy
              </button>
              <button className="text-sm text-gray-400 hover:text-white transition-colors">Terms of Service</button>
              <button 
                onClick={() => navigate('/app/contact')} 
                className="text-sm text-gray-400 hover:text-white transition-colors"
              >
                Contact
              </button>
            </div>
            <div className="flex gap-4">
              <Button variant="outline" size="icon" className="border-gray-700">
                <Link className="h-4 w-4" />
              </Button>
              <Button variant="outline" size="icon" className="border-gray-700">
                <Download className="h-4 w-4" />
              </Button>
            </div>
          </div>
          <div className="flex justify-center">
            <p className="text-sm text-gray-400">
              <a 
                href="https://hobbyworldint.com/portfolio-item/spyfall/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-red-500 hover:text-red-400"
              >
                Spyfall
              </a> is designed by Alexandr Ushan and published by Hobby World
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
} 